module.exports = __webpack_public_path__ + "static/media/certificateImageTopLeft.cd323bbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificateImageTopLeft.png
// module id = 1752
// module chunks = 0